import React from 'react';
import { addReactError } from './addReactError';
const INITIAL_STATE = { didCatch: false, error: null };
// eslint-disable-next-line no-restricted-syntax
export class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.resetError = () => {
            this.setState(INITIAL_STATE);
        };
        this.state = INITIAL_STATE;
    }
    static getDerivedStateFromError(error) {
        return { didCatch: true, error };
    }
    componentDidCatch(error, errorInfo) {
        addReactError(error, errorInfo);
    }
    render() {
        if (this.state.didCatch) {
            return React.createElement(this.props.fallback, {
                error: this.state.error,
                resetError: this.resetError,
            });
        }
        return this.props.children;
    }
}
//# sourceMappingURL=errorBoundary.js.map